import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "block",
  for: "posName"
}
const _hoisted_2 = {
  class: "block",
  for: "posOnlineName"
}
const _hoisted_3 = { class: "flex justify-end gap-2" }

import CButton from "@/components/Button.vue";
import inputText from "primevue/inputtext";
import { ref } from "vue";
import { cloneDeep } from "lodash";
import { useVuelidate } from "@vuelidate/core";
import FormErrors from "@/components/FormErrors.vue";
import { useStore } from "vuex";
import { useI18n } from "vue-i18n";


export default /*#__PURE__*/_defineComponent({
  __name: 'PosForm',
  props: {
  pos: {
    type: Object,
    default: () => ({ spaces: [] }),
  },
  isUpdate: {
    type: Boolean,
    default: false,
  },
},
  emits: ["cancel", "save"],
  setup(__props, { emit }) {

const props = __props;

const store = useStore();
const { t } = useI18n();


const cancel = () => {
  emit("cancel");
  pos.value = cloneDeep(props.pos);
};
const save = async () => {
  if (await v$.value.$validate()) {
    emit("save", cloneDeep(pos.value));
  }
};

const rules = store.getters["pos/rulesToUpdateAPos"];
let pos = ref(cloneDeep(props.pos));
const v$ = useVuelidate(rules, pos, { $lazy: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "flex flex-col gap-y-2",
    onSubmit: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.$t("posName")), 1),
      _createVNode(_unref(inputText), {
        id: "posName",
        type: "text",
        modelValue: _unref(v$).name.$model,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(v$).name.$model) = $event)),
        autocomplete: "off",
        class: _normalizeClass({ 'p-invalid': _unref(v$).name.$invalid })
      }, null, 8, ["modelValue", "class"]),
      _createVNode(FormErrors, {
        errors: _unref(v$).name.$errors
      }, null, 8, ["errors"])
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("onlineName")), 1),
      _createVNode(_unref(inputText), {
        id: "posOnlineName",
        type: "text",
        modelValue: _unref(v$).onlineName.$model,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(v$).onlineName.$model) = $event)),
        autocomplete: "off",
        class: _normalizeClass({ 'p-invalid': _unref(v$).onlineName.$invalid })
      }, null, 8, ["modelValue", "class"]),
      _createVNode(FormErrors, {
        errors: _unref(v$).onlineName.$errors
      }, null, 8, ["errors"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(CButton, {
        class: "p-button-xs p-button-success",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (save()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("save")), 1)
        ]),
        _: 1
      }),
      _createVNode(CButton, {
        class: "p-button-xs p-button-danger",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (cancel()))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("cancel")), 1)
        ]),
        _: 1
      })
    ])
  ], 32))
}
}

})